var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBbSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    transform: "translate(0.890625 0.203125)",
    fill: "url(#pattern0_2_485)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2_485",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_485",
    transform: "scale(0.0384615)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_485",
    width: 26,
    height: 26,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAABHNCSVQICAgIfAhkiAAAAZJJREFUSEvd1TtI1WEYx/HPyUoNxBAdFJpco81BCByEBsE1d110EGkpKILMEIeoIVcnx7YWaSpSNwVHt2gQFMQp7X7hkfeA2P9yzvEk0Tu+l+f7XH9vxTmtyjlx/JOgixw79q2RLJRF1ILrGMXVBPiI19jE11qhRaDLeIiAvcMGfuAGhnEBL7BXCywPFGlawDaW8CvD2AiG8BiHZbA80CS6MY+fOUbi7W1cw9NGQO3Jy0jb5xIDnXiARzgqupsVUQ/u4H6Zl+k8HHqDtXpB/RhPntbCmsIOXtULaiSit1itFxQ1mk11ipkpWtUaRecV3s3rugl04VmanSxYvB1DX7pX6FHRHEUnxRy9xJdTVi4h5mggQQ7KilmkDJHCGXRgBR/S4PbiVtrfxSK+nwVUfXsTg7iSNiK6LaxjOs1PSFHIU+4qE9UyR9twN8Ginnkq0pT/qCq+oQyhj1m62BRQRB0i/ASfMJcV2VlTdzK1rWn+9vH8dM2aCQpowO5hGe9PetFsUNiOj/KPDvwboMxO/f9AvwEYEUYbrO8MUQAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbSearch);
export default __webpack_public_path__ + "static/media/bb-search.e5cf98a438fda04af2cb8e4052a6838c.svg";
export { ForwardRef as ReactComponent };